import { useAccountsStore } from '@/store/accountsStore'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"

interface AccountSelectProps {
  value: string
  onChange: (value: string) => void
}

export function AccountSelect({ value, onChange }: AccountSelectProps) {
  const { accounts } = useAccountsStore()

  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="w-full bg-white dark:bg-gray-800">
        <SelectValue placeholder="Select an account" />
      </SelectTrigger>
      <SelectContent className="bg-white dark:bg-gray-800">
        {accounts.map((account) => (
          <SelectItem 
            key={account.id} 
            value={account.id}
            className="hover:bg-gray-100 dark:hover:bg-gray-700"
          >
            {account.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
} 